import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Colours from '../styles/colours';
import ApiService from '../services.js/apiService';
import useDebounce from './global/use-debounce';
import { IsEmpty } from '../common/checks';

const PageSearch = (props) => {
  const [pageId, setPageId] = useState('');
  const [id, setId] = useState('');
  const [pageName, setPageName] = useState('');
  const debouncedSearch = useDebounce(id, 500);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = async () => {
    try {
      if (id) {
        const data = await ApiService.getPageById(id);
        setIsSearching(false);
        setPageId(data.id || '');
        setPageName(data.name || '');
      } else {
        setPageId('');
        setPageName('');
        setIsSearching(false);
      }
    } catch (err) {
      console.log('Error in PageSearch.handleSearch(): ', err);
      setIsSearching(false);
      setPageId('');
      setPageName('');
    }
  };

  useEffect(() => {
    handleSearch();
  }, [debouncedSearch]);

  const handleClose = () => {
    props.onCancel();
  };

  const onDoneClick = () => {
    /**
     * CHECK pageId and pageName is valid
     */
    const check = !IsEmpty(pageId) && !IsEmpty(pageName);
    if (check) {
      props.onDone({  pageId, pageName });
      handleClose();
    }
  };

  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="sm"
    >
      <DialogTitle className="px-5 pt-5" id="alert-dialog-title">
        Page Search
      </DialogTitle>
      <DialogContent className="px-5">
        <div className="container p-0 m-0">
          <div className="row mb-3">
            <div className="col-md-4">
              <Typography variant="subtitle1" color="inherit" className="my-2" style={{ color: Colours.Black }}>Enter Page Id</Typography>
            </div>
            <div className="col-md-8 my-2">
              <TextField
                id="standard-multiline-flexible"
                value={id}
                type="number"
                onChange={(e) => {
                  setIsSearching(true);
                  setId(e.target.value);
                }}
                variant="outlined"
                size="small"
                fullWidth
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <Typography variant="subtitle1" color="inherit" className="my-2" style={{ color: Colours.Black }}>PageId</Typography>
            </div>
            <div className="col-md-8 my-2">
              <TextField
                id="standard-multiline-flexible"
                multiline
                rowsMax={4}
                disabled
                value={isSearching ? 'searching...' : pageId}
                helperText=""
                variant="outlined"
                size="small"
                fullWidth
              />
            </div>
            <div className="col-md-4">
              <Typography variant="subtitle1" color="inherit" className="my-2" style={{ color: Colours.Black }}>PageName</Typography>
            </div>
            <div className="col-md-8 my-2">
              <TextField
                id="standard-multiline-flexible"
                multiline
                rowsMax={4}
                disabled
                value={isSearching ? 'searching...' : pageName}
                helperText=""
                variant="outlined"
                size="small"
                fullWidth
              />
            </div>
          </div>
        </div>

      </DialogContent>
      <DialogActions className="my-3 pb-3 px-5">
        <Button
          variant="outlined"
          color="default"
          className="px-4 mr-3"
          onClick={handleClose}
        >
          Cancel
        </Button>
          &nbsp;
        <Button
          className="px-4"
          variant="contained"
          style={{ background: isSearching ? Colours.Gray4 : Colours.Secondary, color: Colours.White }}
          disabled={isSearching}
          onClick={onDoneClick}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PageSearch.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDone:   PropTypes.func.isRequired,
};

export default PageSearch;
